import * as R from 'ramda';
export var selectProcesses = function (state) { return R.prop('processes', state); };
export var selectProcessesItems = function (state) { return R.prop('items', selectProcesses(state)); };
export var selectProcessesError = function (state) { return R.prop('error', selectProcesses(state)); };
export var selectProcessesBusy = function (state) { return R.prop('isLoading', selectProcesses(state)); };
//# sourceMappingURL=selectors.js.map